import React from 'react';
import { FiChevronLeft } from 'react-icons/fi';
import { DashboardSidebar } from '@/layouts/dashboard';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function ProjectSidebar(props) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { steps, currentStep, setCurrentStep, edit } = props;

  return (
    <DashboardSidebar
      hasBrand={false}
      viewMode="create"
    >
      <nav className="notebook-sidebar__nav">
        <button
          className="filter-bar__back"
          onClick={() => navigate(-1)}
        >
          <div className="card__icon-wrapper">
            <FiChevronLeft className="card__icon" />
          </div>
          <span className="filter-bar__back-container">
            <span className="filter-bar__title">{'Projetos'}</span>
          </span>
        </button>

        <ul className="step-by-step-nav">
          {steps.map((step, i) => {
            const index = i + 1;

            return (
              <li
                className={`step-by-step-nav__item ${index === currentStep ? 'active' : ''} ${currentStep > index ? 'step-by-step-nav__item--completed' : ''}`}
                onClick={() => edit && setCurrentStep(index)}
                key={i}
              >
                <Link
                  to={edit ? `/lms/criar/modulo/${step.route}` : ''}
                  className="step-by-step-nav__link"
                  style={{ cursor: edit ? 'pointer' : 'default' }}
                >
                  {step.text}
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>
    </DashboardSidebar>
  );
}
